<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" id="muven-amount-of-money-earned-filter-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filtro de valor recebido</h5>
                    </div>

                    <div class="modal-body">
                        <div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data inicial</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="amountOfMoneyEarnedFilter.date.start" />
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data final</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="amountOfMoneyEarnedFilter.date.end" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" 
                            class="btn btn-primary"
                            :disabled="loadingFilter"
                            @click="getInfoByFilter(amountOfMoneyEarnedFilter)">
                            Filtrar

                            <fa icon="sync-alt" spin v-show="loadingFilter"/>
                        </button>
                        
                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="clearFilter(amountOfMoneyEarnedFilter)">Restaurar</button>

                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="closeFilterModal(ID_MODAL_FILTER)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Valor de vendas

                    <button type="button" 
                        class="btn btn-outline-secondary btn-sm float-right"
                        @click="showFilterModal(ID_MODAL_FILTER)">
                        <fa icon="calendar-alt" />
                    </button>
                </p>

                <p class="muven-card-subtitle">                    
                    <span>{{amountOfMoneyEarnedFilter.dateSubmitted.start | dateFilter}}</span> até <span>{{amountOfMoneyEarnedFilter.dateSubmitted.end | dateFilter}}</span>
                    <span v-show="amountOfMoneyEarnedFilter.hasChannelList()">
                        <br>
                        <span>Canais: {{amountOfMoneyEarnedFilter.getChannelListDescription()}}</span>
                    </span>
                    <span v-show="amountOfMoneyEarnedFilter.hasStoreList()">
                        <br>
                        <span>Lojas: {{amountOfMoneyEarnedFilter.getStoreListDescription()}}</span>
                    </span>
                </p>
            </div>

            <div>
                <highcharts :options="amountOfMoneyEarnedChartOptions" ref="chart"/>
            </div>
        </div>
    </div>    
</template>

<script>
import Highcharts from 'highcharts'
import dashboardService from '@/dashboard/services/DashboardService'
import modalService from '@/utils/services/ModalService'
import {DashboardAmountOfMoneyEarnedFilterModel} from '@/dashboard/models/DashboardAmountOfMoneyEarnedFilterModel'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import { DashboardAverageTicketFilterModel } from '../models/DashboardAverageTicketFilterModel'
import dashboardFilterMixin from '@/dashboard/mixins/DashboardFilterMixin'
import { createGraphic } from '@/utils/normalizers/GraphicNormalizer'
import {format} from 'date-fns'
import {meanBy, round} from 'lodash'
import { averageColor } from '@/dashboard/constants/Color'
import { adjustsDate } from "@/utils/normalizers/DateNormalizer"

const ID_MODAL_FILTER = '#muven-amount-of-money-earned-filter-modal'

export default {
    name: 'AmountOfMoneyEarnedCmp',
    mixins: [
        dashboardFilterMixin,
    ],
    data() {
        return {
            ID_MODAL_FILTER,
            loadingFilter: false,
            amountOfMoneyEarnedFilter: new DashboardAmountOfMoneyEarnedFilterModel(),
            amountOfMoneyEarnedList: [],
            amountOfMoneyEarnedChartOptions: createGraphic({
                chart: {
                    type: 'column',
                    height: 300,
                },
                xAxis: {
                    categories: [],
                },
                tooltip: {
                    shared: true
                },
                series: [
                    {
                        type: 'column',
                        name: 'Valor de vendas',
                        data: [],
                    },
                    {
                        type: 'line',
                        name: 'Média do período',
                        data: [],
                        color: averageColor
                    }
                ]
            }),   
        }
    }, 
    filters: {
        dateFilter,
    },
    methods: {
        async getInfoByFilter(filter) {
            this.loadingFilter = true

            filter.fillDateWhenEmpty()
            filter.updatesFilterSubmitted()

            await this.drawGraphic(filter)

            this.loadingFilter = false
            this.closeFilterModal(this.ID_MODAL_FILTER)
        },
        async drawGraphic(filter) {
            this.amountOfMoneyEarnedFilter.updatesFilterSubmittedWith(filter)
            this.amountOfMoneyEarnedList = await dashboardService.getAmountOfMoneyEarned(filter)

            this.$refs.chart.chart.xAxis[0].setCategories(this.amountOfMoneyEarnedList.map((a) => {
                return format(adjustsDate(a.date), 'dd/MM')
            }))

            this.$refs.chart.chart.series[0].setData(this.amountOfMoneyEarnedList.map((a) => {
                return {
                    y: a.value,
                }
            }))

            this.$refs.chart.chart.series[1].setData(this.amountOfMoneyEarnedList.map((a) => {
                return {
                    y: round(meanBy(this.$refs.chart.chart.series[0].data, 'y'), 2),
                }
            }))
        },
    },
    async mounted() {
        await this.drawGraphic(this.amountOfMoneyEarnedFilter)
    },
}
</script>
